import { render } from "./CategoryManagerView.vue?vue&type=template&id=1c2db9fa"
import script from "./CategoryManagerView.vue?vue&type=script&lang=js"
export * from "./CategoryManagerView.vue?vue&type=script&lang=js"

import "./CategoryManagerView.vue?vue&type=style&index=0&id=1c2db9fa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__